import { useState, useEffect } from "react";
import WaterLevel from "../../components/waterLevel";
import Map from "../../components/Map";
import Clock from "../../components/Clock";
import search from "/assets/icon/Search.svg";
import filter from "/assets/icon/Filter.svg";
import "./styles/WaterLevelPage.css";
import eye from "/assets/Eye.png";
import WaterLeveltitle from "/Group.png?url";
import UserStatus from "../../components/UserStatus";
import Detail from "../../components/Detail";
import Lamp from "/assets/lamp.png";


function WaterLevelPage({ waterLevel, currentWaterLevel }) {

  const [activeDetail, setActiveDetail] = useState(null);

  const handleDetailClick = (row) => {
    setActiveDetail(row);
  };

  const handleCloseDetail = () => {
    setActiveDetail(null);
  };

  const tableData = [
    {
      no: 1,
      stationCode: "A254006",
      stationName: "แม่ฮ่องสอน",
      coordinates: "13.813,100.077",
      highFloodLevel: 129,
      highWaterLevelChange: "+18",
      waterLevel: "ปกติ", // Assuming 'ปกติ' means normal water level
      status: "ปกติ", // Assuming 'ปกติ' means the instrument is functioning normally
    },
    {
      no: 2,
      stationCode: "A254006",
      stationName: "แม่ฮ่องสอน",
      coordinates: "13.813,100.077",
      highFloodLevel: 138,
      highWaterLevelChange: "+12",
      waterLevel: "ปกติ",
      status: "ปกติ",
    },
    // ... more data rows
  ];

  // Function to render status indicator based on the status
  const renderStatus = (status) => {
    if (status === "ปกติ") {
      return (
        <div style={{ color: "green" }}>
          ปกติ {/* Replace with actual icons or images as needed */}
        </div>
      );
    }
    // Add more conditions for different statuses if needed
  };

  return (
    <div className="containerPage">
      <div className="sections1">
        <h1>ระดับน้ำ</h1>
        <h2>
          <Clock />
        </h2>
      </div>
        

      <div className="sections2">
        <div className="area-chart-container">
        <img src={Lamp} alt="Lamp" className="Lamp" />
          <div className="waterleve-ltitle">
         
            <img src={WaterLeveltitle} alt="WaterLeveltitle" />
          </div>
          <li className="waterli">
            <WaterLevel
              waterLevel={waterLevel}
              currentWaterLevel={currentWaterLevel}
            />
          </li>
        </div>
        <div className="areaMap">
          <Map />
        </div>
      </div>
        <div className="section3">
          <div className="led-section">
            <div className="search-bar">
              <img src={search} alt="search" className="search-user" />
              <input
                type="text"
                placeholder="ค้นหาชื่อ, หมายเลขโทรศัพท์, หรืออีเมล"
              />
              <div>
                <img src={filter} alt="filter" className="filter-user" />
              </div>
            </div>
            <table>
              <thead>
                <tr>
                  <th>No</th>
                  <th>รหัสเสา</th>
                  <th>ชื่อเสา</th>
                  <th>พิกัด</th>
                  <th>ระดับน้ำเฉลี่ย</th>
                  <th>ระดับตลิ่ง</th>
                  <th>ระดับน้ำ</th>
                  <th>สถานะเปิดปิด</th>

                  <th></th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.no}</td>
                    <td>{row.stationCode}</td>
                    <td>{row.stationName}</td>
                    <td>{row.coordinates}</td>
                    <td>{row.highFloodLevel}</td>
                    <td>{row.highWaterLevelChange}</td>
                    <td><UserStatus/></td>
                    <td><UserStatus/></td>
                    <td>
                    <img src={eye} onClick={() => handleDetailClick(row)} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {activeDetail && (
        <Detail
          title="ระดับน้ำ"
          weatherData={activeDetail}
          onClose={handleCloseDetail}
        >
          <label>ความจุลำน้ำ (%)</label>
          <strong>###</strong>
          <label>ระดับน้ำ (ม.รทก.)</label>
          <strong>###</strong>
          <label>สูงกว่าตลิ่ง (ม.รทก.)</label>
          <strong>###</strong>
          
        </Detail>
      )}
      </div>
   
  );
}

export default WaterLevelPage;
